// extracted by mini-css-extract-plugin
module.exports = {"container":"content_container__aim2s","header":"content_header__G6IRy","title":"content_title__2iCsS","text":"content_text__cX4Xb","content":"content_content__twclt"};